<template>
        <div class="preview-immobile-ctn" v-bind:class="{ previewopened: show }">
            <div class="preview-close" @click="closeEvent()">
                <i class="fa fa-times-circle" aria-hidden="true"></i>
            </div>
             <div class="row" v-if="immobile">
                <div class="col-md-12 text-center">
                    <h2>{{ immobile.tipologia }}</h2>
                    <h1>{{ immobile.price }}</h1>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    name: 'PreviewImmobile',
    props: ['immobile'],
    methods: {
         closeEvent() {
            this.$emit('close');
        }
        
    },
    mounted() {
       
    },
    watch: { 
          immobile: function(newVal, oldVal) { // watch it
          if(newVal) {
              this.show = true;
          } else {
              this.show = false;
          }
        }
    },
    data() {
        return {
            show: false
        }
    }

}
</script>

<style lang="scss">
    @import './Styles/previewimmobile.scss';
</style>
